<template>
  <div v-loading="pageLoading">
    <div>
      <el-form :model="form"
               style="margin: auto; width: 1000px">
        <el-form-item label="賬號"
                      :label-width="formLabelWidth">
          <el-input v-model="form.account"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="密碼"
                      :label-width="formLabelWidth">
          <el-input v-model="form.pwd"
                    autocomplete="off"
                    style="width: 80%"></el-input>
        </el-form-item>
        <el-form-item label="分公司"
                      :label-width="formLabelWidth">
          <el-select v-model="form.regionId"
                     placeholder="請選擇分公司"
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in region"
                       :key="item.id"
                       :label="item.regionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="部門/物業"
                      :label-width="formLabelWidth">
          <el-select v-model="form.branchId"
                     placeholder="請先選擇分公司"
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in filiale"
                       :key="item.id"
                       :label="item.branchName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="用戶組別"
                      class="special_color"
                      :label-width="formLabelWidth">
          <el-select v-model="form.departmentId"
                     placeholder="請先選擇部門/物業"
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in department"
                       :key="item.id"
                       :label="item.departmentName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="職位"
                      :label-width="formLabelWidth"
                      class="special_color">
          <el-select v-model="form.positionId"
                     placeholder="請先選擇用戶組別"
                     style="width: 80%"
                     disabled>
            <el-option v-for="item in position"
                       :key="item.id"
                       :label="item.positionName"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="姓名"
                      :label-width="formLabelWidth">
          <el-select v-model="form.name"
                     placeholder="请选择姓名"
                     style="width: 80%"
                     disabled>
            <el-option :label="form.name"
                       :value="form.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="角色"
                      :label-width="formLabelWidth">
          <el-select v-model="form.manRoleId"
                     placeholder="请选择角色"
                     style="width: 80%">
            <el-option v-for="item in role"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="課程審核"
                      :label-width="formLabelWidth">
          <el-radio-group v-model="form.type"
                          style="width: 550px">
            <el-radio :disabled="isPersonnel"
                      label="0">非審核人員</el-radio>
            <el-radio :disabled="isPersonnel"
                      label="3">總公司內部審核</el-radio>
            <!-- <el-radio label="1">公司內部審核</el-radio>
            <el-radio :disabled="isPersonnel"
                      label="2">部門內部審核</el-radio> -->
          </el-radio-group>
        </el-form-item>
      </el-form>
      <div class="dialog-footer">
        <el-button @click="$router.back(-1)">取 消</el-button>
        <el-button type="primary"
                   @click="addUser" :loading="submitLoading">確 定</el-button>
      </div>
      <el-button class="btn"
                 @click="$router.back(-1)">返 回</el-button>
    </div>
  </div>
</template>

<script>
var that;
export default {
  data () {
    return {
      pageLoading: false,

      form: {
        account: "",
        pwd: "",
        name: "",
        id: "",
        regionId: "",
        branchId: "",
        departmentId: "",
        positionId: "",
        type: "0",
        manRoleId: "",
      },
      formLabelWidth: "130px",
      region: [],
      filiale: [],
      department: [],
      position: [],
      role: [],
      userId: "",
      password: "",
      isPersonnel: false,
      submitLoading: false
    };
  },
  mounted () {
    $("#pageHead").text("修改後台用戶");
    // 分公司
    this.$store.dispatch('commonData/getBranchList').then(() => {
      this.filiale = this.$store.state.commonData.branchList
    })
    // 部門
    this.$store.dispatch('commonData/getDepartmentList').then(() => {
      this.department = this.$store.state.commonData.departmentList
    })
    // 地區
    this.$store.dispatch('commonData/getRegionList').then(() => {
      this.region = this.$store.state.commonData.regionList
    })
    //  職位
    this.$store.dispatch('commonData/getPositionList').then(() => {
      this.position = this.$store.state.commonData.positionList
    })
    // 角色
    this.$store.dispatch('commonData/getRoleList').then(() => {
      this.role = this.$store.state.commonData.roleList
    })

    this.pageLoading = true
    this.axios({
      url: "/manage/getManUser",
      params: {
        id: that.userId,
      },
    }).then((res) => {
      var msg = res.result[0],
        form = that.form;
      form.account = msg.account
      form.pwd = msg.password
      that.password = msg.password
      form.manRoleId = msg.manRoleId
      form.name = msg.comUserName
      form.id = msg.comUserId
      form.regionId = msg.manRegionId
      form.branchId = msg.manBranchId
      form.departmentId = msg.manDepartmentId
      form.type = msg.type.toString()
      form.positionId = msg.manPositionId
      that.department.forEach((item) => {
        if (item.id == msg.manDepartmentId && item.departmentName == "人事部") {
          that.isPersonnel = true;
          form.type = "1";
        }
      });
      this.pageLoading = false
    });
  },
  methods: {
    addUser () {
      var form = that.form;
      var msg = {
        account: form.account,
        manRoleId: form.manRoleId,
        comUserId: form.id,
        id: that.userId,
        type: form.type,
      };
      if (that.password != form.pwd) {
        // 判断密码是否改变
        if (form.pwd.length < 0) {
          that.$message({
            type: "warning",
            message: "請填寫密碼!",
          });
          return;
        }
        msg["password"] = form.pwd;
      }
      for (let item in msg) {
        if (msg[item] === "") {
          that.$message({
            type: "warning",
            message: "請將信息填寫完整!",
          });
          return;
        }
      }
      this.pageLoading = true
      this.axios({
        url: "/manage/updateManUser",
        params: msg,
        method: "post",
      }).then((res) => {
        if (res) {
          that.$message({
            type: "success",
            message: "修改成功!",
          });
          setTimeout(() => {
            this.$router.go(-1);
            this.pageLoading = false
          }, 1000);
        }
      });
    },
  },
  created () {
    that = this;
    this.userId = sessionStorage.getItem("userId");
  },
};
</script>

<style scoped>
/* .btn {
	margin-left: 20px;
} */

.dialog-footer {
  display: flex;
  justify-content: space-around;
  width: 400px;
  margin: auto;
}
.el-form-item {
  width: 500px;
  display: inline-block;
}
.btn {
  position: absolute;
  top: 90px;
  right: 45px;
}
</style>
